// services/cookieService.js
export class CookieService {
  // Save form data to cookies
  setUserData(formData) {
    const userData = {
      name: formData.name || '',
      email: formData.email || '',
      phone: formData.phone || '',
      lastUpdated: new Date().toISOString()
    };
    
    this.setCookie('user_data', JSON.stringify(userData), 365); // 1 year (365 days)
    localStorage.setItem('user_data', JSON.stringify(userData)); // Fallback
  }

  // Get user data from cookies
  getUserData() {
    // Try localStorage first (faster), then cookies
    try {
      const localData = localStorage.getItem('user_data');
      if (localData) return JSON.parse(localData);
    } catch (e) {
      console.warn('Error reading from localStorage:', e);
    }

    // Fallback to cookies
    const cookieData = this.getCookie('user_data');
    return cookieData ? JSON.parse(cookieData) : null;
  }

  // Clear user data
  clearUserData() {
    this.setCookie('user_data', '', -1); // Expire immediately
    localStorage.removeItem('user_data');
  }

  // Helper method to set cookie
  setCookie(name, value, days) {
    if (typeof document === 'undefined') return; // SSR safety
    
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    const secure = process.env.NODE_ENV === 'production' ? ';secure' : '';
    document.cookie = `${name}=${encodeURIComponent(value)};${expires};path=/${secure}`;
  }

  // Helper method to get cookie
  getCookie(name) {
    if (typeof document === 'undefined') return null; // SSR safety
    
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  }
}

export default new CookieService();